module.exports = __webpack_public_path__ + "img/ejoyGlot.66e0ea9e.svg";